const MottoData = [
  {
    index: 0,
    name: 'Learn',
    description:
      "We believe in the power of continuous learning. Our community is a dynamic learning environment, providing students with opportunities to master cutting-edge technologies such as UiPath's robotic process automation, web development, machine learning, RPA/AI, UI automation, and more. Through curated resources, workshops, and collaborative projects, we facilitate a culture of perpetual learning.",
  },
  {
    index: 1,
    name: 'Connect',
    description:
      'Networking is at the heart of our community. We recognize the significance of fostering connections among aspiring minds. Students can engage with peers, industry professionals, and mentors, creating a vibrant network that extends beyond the confines of academia. These connections not only facilitate knowledge exchange but also open doors to diverse perspectives and career opportunities.',
  },
  {
    index: 2,
    name: 'Collaborate',
    description:
      "We encourage our members to go beyond the basics and delve deeper into their areas of interest. Collaboration signifies the exploration of ideas, the creation of innovative solutions, and the expansion of one's skill set. Whether it's contributing to open-source projects, organizing events, or participating in hackathons, we believe in empowering students to elaborate on their knowledge and skills, turning theoretical learning into practical expertise.",
  },
]

export default MottoData
